import React, { useState } from "react";
import styles from "./styles.module.css";

const ExlyButtonToggle = (props) => {
  const [active, setActive] = useState(props.selected);

  const handleToggle = (e, i) => {
    setActive(i);
    props.onClick(e, i);
  };

  const switches = props.switches.map((_switch, index) => (
    <div
      key={_switch}
      className={active === index ? styles.selected : ""}
      onClick={(e) => handleToggle(e, index)}
    >
      {_switch}
    </div>
  ));

  return <div className={styles.container}>{switches}</div>;
};

export default ExlyButtonToggle;
